import { useState, useEffect, createContext, useContext, useCallback, useRef } from 'react'
import { Check, Copy, X } from 'lucide-react'
import { gsap } from 'gsap'
import styles from './Toast.module.css'

const ToastContext = createContext()

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type = 'success') => {
    const id = Math.random().toString(36).substr(2, 9)
    setToasts((prev) => [...prev, { id, message, type }])
    
    // Auto remove after 3 seconds
    setTimeout(() => {
      removeToast(id)
    }, 3000)
  }, [])

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className={styles.toastContainer}>
        {toasts.map((toast) => (
          <ToastItem key={toast.id} toast={toast} onRemove={() => removeToast(toast.id)} />
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)

function ToastItem({ toast, onRemove }) {
  const itemRef = useRef(null)

  useEffect(() => {
    gsap.fromTo(itemRef.current, 
      { x: 100, opacity: 0, scale: 0.9 },
      { x: 0, opacity: 1, scale: 1, duration: 0.5, ease: 'back.out(1.7)' }
    )
  }, [])

  const handleClose = () => {
    gsap.to(itemRef.current, {
      x: 100,
      opacity: 0,
      scale: 0.9,
      duration: 0.4,
      ease: 'power3.in',
      onComplete: onRemove
    })
  }

  return (
    <div className={styles.toast} ref={itemRef}>
      <div className={styles.iconBox}>
        {toast.type === 'success' ? <Check size={18} /> : <Copy size={18} />}
      </div>
      <p className={styles.message}>{toast.message}</p>
      <button className={styles.closeBtn} onClick={handleClose}>
        <X size={14} />
      </button>
      <div className={styles.progress} />
    </div>
  )
}
